const module = angular.module('app.resources');

let lastRequesterAddress = null;

module.config(($httpProvider) => {
  'ngInject';
  $httpProvider.interceptors.push(($q) => {
    return {
      response: (response) => {
        const requesterAddress = response.headers('BoxCast-Requester-Address');
        if (requesterAddress) {
          lastRequesterAddress = requesterAddress;
        }
        return response;
      },
    };
  });
});

module.service(
  'Requester',
  class AuthService {
    get address() {
      return lastRequesterAddress;
    }
  }
);



// WEBPACK FOOTER //
// ./app/resources/requester-address.js